import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetOrderListSlice = createSlice({
    name: "getOrderList",
    initialState,
    reducers: {
        getOrderListRequest(state) {
            state.loading = true;
        },
        getOrderListRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getOrderListRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        clearOrderResponse(state) {
            state.response = undefined;
            state.error = undefined;
            state.loading = false;
        }
    },
});

export const {
    getOrderListRequest,
    getOrderListRequestSuccess,
    getOrderListRequestError,
    clearOrderResponse
} = GetOrderListSlice.actions;

export default GetOrderListSlice.reducer;
